import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { userLogout, zerodhaLogin } from '../../actions/userActions';
import { getUserFromToken } from '../../utils/utility';

function NavLink() {
  const user = getUserFromToken();
  const { role = '' } = user;
  const dispatch = useDispatch();
  return (
    <Navbar expand="lg" className="app-top-navbar bg-body-tertiary px-2 px-md-3">
      <Container fluid>
        {/* <Navbar.Brand href="#">Navbar scroll</Navbar.Brand> */}
        <Navbar.Toggle aria-controls="navbarScroll" />
        <Navbar.Collapse id="navbarScroll">
          <Nav
            className="me-auto my-2 my-lg-0"
            style={{ maxHeight: '100px' }}
            navbarScroll
          >
            {/* <Nav.Link href="/">Home</Nav.Link>
            <Nav.Link href="/blogs">Blogs</Nav.Link> */}
            <Link to="/" className="nav-link">Home</Link>
            {/* <Link to="/blogs" className="nav-link">Blogs</Link> */}
            {/* <Nav.Link href="/contact">
            Contact
            </Nav.Link> */}
            {role == 'ADMIN' ? <Link to="/admin" className="nav-link">
              Admin
            </Link> : ''}
            <Link to="/zerodha/execute" className="nav-link">Zerodha</Link>
            <NavDropdown title="Account" id="navbarScrollingDropdown">
              <NavDropdown.Item href="/account">Edit</NavDropdown.Item>
              {/* <NavDropdown.Item href="#action4">
                Another action
              </NavDropdown.Item> */}
              {/* <NavDropdown.Divider /> */}
              <NavDropdown.Item href="#" onClick={() => dispatch(userLogout())}>
                Logout
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
          {/* <Form className="nav-search-form d-flex align-items-center">
            <Form.Control
              type="search"
              placeholder="Search"
              className="me-2 nav-search-input"
              aria-label="Search"
            />
            <Button variant="outline-success" className="nav-search-btn">Search</Button>
          </Form> */}
          <div className="d-flex align-items-center">
            <Button
              // as={Link}
              onClick={() => dispatch(zerodhaLogin())}
              // to="/zerodha/login"
              // target="_blank"
              rel="noreferrer"
              variant="primary"
              className="nav-search-btn"
            >
              Zerodha Login
            </Button>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavLink;
